<template>
  <el-dialog title="收费标准" :visible.sync="dialogTableVisible" width="1200px">
    <com-table :columns="columns" :api="api" ref="tableRef" :default-params="defaultParams">
      <template #chargePlanType="row">
        <div>{{ chargePlanTypes[row.data.chargePlanType] }}</div>
      </template>
      <template #status="row">
        <div>{{ status[row.data.status] }}</div>
      </template>
      <template #operation="row">
        <el-button type="primary " @click="handleDetail(row.data)" class="mb-5px" size="mini"
          >查看</el-button
        >
        <el-button type="danger" @click="handleDel(row.data)" class="mb-5px" size="mini"
          >删除</el-button
        >
      </template>
    </com-table>
  </el-dialog>
</template>

<script>
import { feeStandardsListApi, deleteCommunityApi } from '@/api/community'

export default {
  data() {
    return {
      api: feeStandardsListApi,
      dialogTableVisible: false,
      defaultParams: {},
      columns: [
        {
          label: '编号',
          prop: 'chargePlanNumber'
        },
        {
          label: '名称',
          prop: 'chargePlanName'
        },
        {
          label: '收费类型',
          prop: 'chargePlanType',
          type: 'slot',
          slotName: 'chargePlanType',
        },
        {
          label: '生效时间',
          prop: 'effectiveTime',
          width: 120
        },
        {
          label: '状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status',
        },
        {
          label: '修改人',
          prop: 'refUpdateUserName'
        },
        // {
        //   label: '操作',
        //   prop: 'operation',
        //   type: 'slot',
        //   slotName: 'operation',
        //   fixed: 'right',
        //   minWidth: '150'
        // }
      ],

      chargePlanTypes: {
        1: '功率计费',
        2: '功率+电费',
        3: '服务费+电费',
      },
      status: {
        0: '已失效',
        1: '生效中',
        2: '待生效',
      }
    }
  },
  methods: {
    open(row) {
      this.defaultParams.refResidentialArea = row.code
      this.dialogTableVisible = true
    },
    handleDetail(row) {
      
    },
    handleDel(row) {
      
    },
  }
}
</script>

<style lang="scss" scoped></style>
